import React from "react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label?: string;
};
export function Countdown({
  label = "The special offer ends in:"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Min"
  }, {
    value: seconds,
    unit: "Sec"
  }];
  return <div className="w-full max-w-xl rounded-2xl border-2 border-alert/60 bg-alert/10 px-4 py-4" role="timer" aria-live="off" data-id="element-19" data-mp="3c25u3hqume3r">
      <p className="text-center font-display text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-20" data-mp="3h20fj5ruubhf">{label}</p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" data-id="element-21" data-mp="3259eyt6g2tq8">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-22" data-mp="3731heh4pty8o" data-mpi={i}>
            <div className="flex w-[78px] flex-col items-center rounded-xl bg-alert py-2 sm:w-24" data-id="element-23" data-mp="10clbcipw249x">
              <span className="font-display text-3xl font-black tabular-nums leading-none text-white sm:text-4xl" data-id="element-24" data-mp="15b6a0dphsfw9">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1 text-[11px] font-bold uppercase tracking-wider text-white/90" data-id="element-25" data-mp="t23dxk2j3pg3">{u.unit}</span>
            </div>
            {i < units.length - 1 && <span className="font-display text-2xl font-black text-alert" data-id="element-26" data-mp="17qgder0trqfc">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}